import React from 'react';

import './BlockedLayer.css';

const BlockedLayer = () => {
  return (
    <section
      className="BlockedLayer"
    />
  )
};

export default BlockedLayer;